var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"disabled":_vm.disabled,"fab":"","small":"","color":"primary","to":{ name: _vm.toName },"depressed":""}},on),[_c('v-icon',[_vm._v("add")])],1)]}}])},[_c('span',[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }